import { GuardHelper } from "./crossconcern/helpers/generic/guard.helper";
import { EMPTY_PATH, BACKOFFICE_PATH, NURSERIES_PATH, FRONTOFFICE_LOGIN_PATH, BACKOFFICE_LOGIN_PATH } from "./crossconcern/utilities/properties/path.property";
import { BackOfficeComponent } from "./ui/backoffice";
import { BACKOFFICE_ROUTES } from "./ui/backoffice/backoffice.routes";
import { BACKOFFICE_LOGIN_ROUTE, FRONTOFFICE_LOGIN_ROUTE, NURSERIES_ROUTE, PRIVATE_MAIN_ROUTE, ROOT_ROUTE } from "./crossconcern/utilities/properties/routename.property";
import { NURSERIES_ROUTES } from "./ui/nurseries/nurseries.routes";
import { BackofficeGuardHelper } from "./crossconcern/helpers/generic/backofficeguard.helper";
import { FrontofficeloginComponent } from "./ui/frontofficelogin";
import { BackofficeloginComponent } from "./ui/backofficelogin";
var ɵ0 = { routeName: FRONTOFFICE_LOGIN_ROUTE }, ɵ1 = { routeName: BACKOFFICE_LOGIN_ROUTE }, ɵ2 = { routeName: PRIVATE_MAIN_ROUTE }, ɵ3 = { routeName: NURSERIES_ROUTE };
export var ROUTES = [
    {
        path: FRONTOFFICE_LOGIN_PATH,
        component: FrontofficeloginComponent,
        data: ɵ0
    },
    {
        path: BACKOFFICE_LOGIN_PATH,
        component: BackofficeloginComponent,
        data: ɵ1
    },
    {
        path: BACKOFFICE_PATH,
        component: BackOfficeComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        children: BACKOFFICE_ROUTES,
        data: ɵ2
    },
    {
        path: EMPTY_PATH,
        pathMatch: "full",
        redirectTo: NURSERIES_PATH
    },
    {
        path: NURSERIES_PATH,
        children: NURSERIES_ROUTES,
        canActivate: [
            GuardHelper
        ],
        data: ɵ3
    },
    { path: "**", redirectTo: NURSERIES_PATH }
];
var recursiveMapping = function (routes, fatherPath, map) {
    if (fatherPath === void 0) { fatherPath = ""; }
    if (map === void 0) { map = {}; }
    routes.forEach(function (route) {
        var currentPath = fatherPath + (route.path ? "/" + route.path : "");
        if (route.data && route.data.routeName) {
            map[route.data.routeName] = currentPath;
        }
        if (route.children) {
            recursiveMapping(route.children, currentPath, map);
        }
    });
    map[ROOT_ROUTE] = "/";
    return map;
};
var ɵ4 = recursiveMapping;
export var ROUTE_PATH_BY_NAME = recursiveMapping(ROUTES);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
